import Heading from "@commons/Typography/Heading";

function Section({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <section className="p-4 rounded-md shadow-md bg-white w-full min-w-76 relative">
      <Heading size="sm" className="mb-2">
        {title}
      </Heading>
      {children}
    </section>
  );
}

export default Section;
